import React from 'react';
import { Label } from 'react-bootstrap';
import { OUT_OF_STOCK_MODIFIER_LEVEL } from '../../../util/Constants';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../translations/lang/en-US.json';

class OutOfStockLable extends React.Component {
	render() {
		let pullRight =
			this.props.right === false
				? 'light-type-of-outofstock'
				: 'type-of-outofstock';

		if (!this.props.notavailable) {
			return null;
		}

		return (
			<div className={`${pullRight} font-small-xs`}>
				<Label bsStyle="danger">
					{this.props.notavailable === OUT_OF_STOCK_MODIFIER_LEVEL ? (
						<FormattedMessage
							id="modifierOutOfStock"
							defaultMessage={defaultMsg.modifierOutOfStock}
						/>
					) : (
						<FormattedMessage
							id="itemOutOfStock"
							defaultMessage={defaultMsg.itemOutOfStock}
						/>
					)}
				</Label>
			</div>
		);
	}
}

export default OutOfStockLable;



// WEBPACK FOOTER //
// ./src/views/inventory/components/OutOfStockLable.jsx